export const formatPercentage = (
  val: number | string,
  type: 'legacy' | 'super-base-points' = 'legacy',
  minimumFractionDigits?: number,
  maximumFractionDigits?: number
) => {
  if (typeof val === 'string') val = Number(val);

  // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
  if (isNaN(val)) return 'Invalid percentage';

  if (type === 'super-base-points') val = val / 100000; // max 3 decimals: 1.325%

  const resolvedMaximumFractionDigits =
    maximumFractionDigits ?? (type === 'super-base-points' ? 3 : 2);

  return val.toLocaleString('en', {
    style: 'percent',
    maximumFractionDigits: resolvedMaximumFractionDigits,
    minimumFractionDigits,
  });
};
